import {
  getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdMutationFetcher,
  getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { PutApiV1ThreeLetterCodePartnerAdminsClientsClientId200 } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

/**
 * 利用企業更新APIを実行するカスタムフック（新版）
 *
 * @param threeLetterCode - パートナーコード
 * @param clientId - クライアントID（数値）
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const usePutPartnerAdminsClient = (
  threeLetterCode: string,
  clientId: number,
  options?: {
    onSuccess?: (data: PutApiV1ThreeLetterCodePartnerAdminsClientsClientId200) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  const clientIdStr = String(clientId);
  return useMutation(
    getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdMutationKey(threeLetterCode, clientIdStr),
    getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdMutationFetcher(
      threeLetterCode,
      clientIdStr
    ),
    options
  );
};
